import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Base } from '../base';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-weddings',
  templateUrl: './weddings.component.html',
  styleUrls: ['./weddings.component.scss']
})
export class WeddingsComponent extends Base implements OnInit {
  weddings: any = [];
  weddingsPhotosLimited: any;
  imagesCounter: number;
  defaultImagesNumber: number = 6;

  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.dataService.getWedding().subscribe(response => {
      this.weddings = response.Matrimoni;
      this.resetImages();
    });
  }

  chargeMoreImages() {
    this.weddingsPhotosLimited = this.weddings.foto.slice(0, this.imagesCounter + this.defaultImagesNumber);
    this.imagesCounter += this.defaultImagesNumber;
  }

  resetImages() {
    this.imagesCounter = this.defaultImagesNumber;
    this.weddingsPhotosLimited = this.weddings.foto.slice(0,this.defaultImagesNumber);
  }

  showButtonMore() {
    if (!isNullOrUndefined(this.weddings) && !isNullOrUndefined(this.weddings.foto))
      return this.imagesCounter < this.weddings.foto.length;

    return false;
  }
}
